/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is the ratio simplified?`)
};

const es_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se simplifica la relación?`)
};

const de_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird das Verhältnis vereinfacht?`)
};

const nl_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt de verhouding vereenvoudigd?`)
};

const fr_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le rapport est-il simplifié ?`)
};

const it_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene semplificato il rapporto?`)
};

const pt_br2_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a taxa é simplificada?`)
};

const pt_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é a proporção simplificada?`)
};

const ja_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比率はどのように簡略化されますか？`)
};

const zh_ar_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比例是如何化简的?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_faq1_q", locale)
	if (locale === "en") return en_ar_faq1_q(inputs)
	if (locale === "es") return es_ar_faq1_q(inputs)
	if (locale === "de") return de_ar_faq1_q(inputs)
	if (locale === "nl") return nl_ar_faq1_q(inputs)
	if (locale === "fr") return fr_ar_faq1_q(inputs)
	if (locale === "it") return it_ar_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_ar_faq1_q(inputs)
	if (locale === "pt") return pt_ar_faq1_q(inputs)
	if (locale === "ja") return ja_ar_faq1_q(inputs)
	return zh_ar_faq1_q(inputs)
};